<div class="course-template" *ngIf="template$ | async as template">
  <div class="slider-banner">
    <div ngImagePixel #bannermageHolder="imagePixel" class="banner-item">
      <img
          class="img-fluid"
          src="{{ getDefaultMedia(template.media) }}?{{
            bannermageHolder.imagePixel
          }}&&dpr=2&{{ bannermageHolder.aspectRation }}&fit=crop&auto=compress"
          alt="banner-image"
        />

      <div class="carousel-caption">
        <div class="container">
          <div class="row justify-content-between">
            <div
              class="
                col-12 col-sm-12 col-md-9 col-lg-7 col-xl-6
                text-left
                order-1 order-md-0
              ">
              <h6 class="h6 text-uppercase">{{translationScope+'.titles.course' | transloco}}</h6>
              <h1 class="h1">{{ template.title }}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <main>
    <section>
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-8 offset-md-2">
            <div class="section-item">
              <div class="d-flex flex-row flex-wrap justify-content-between">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-row">
                      <img class="clock-icon" alt="Clock" />
                      <div>
                        <h2>{{translationScope+'.duration' | transloco}}</h2>
                        {{ template.duration }} timer
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-row">
                      <img class="note-icon" alt="Clock" />
                      <div>
                        <h2>{{translationScope+'.exam' | transloco}}</h2>
                        {{ (translationScope+'.'+(template.hasExam ? 'yes' : 'no'))  | transloco}}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-row">
                      <img class="boat-icon" alt="Clock" />
                      <div>
                        <h2>{{translationScope+'.practical_part' | transloco}}</h2>
                        {{ (translationScope+'.'+(template.isPractical ?  'yes' : 'no')) | transloco }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="section-item">
              <app-about-template
                [description]="template.content"
                [descriptionTitle]="translationScope+'.titles.course_content' | transloco">
              </app-about-template>
            </div>
          </div>

          <div class="col-12"></div>
        </div>

        <div class="row">
          <div class="col-12">
            <ng-container *ngIf="getVideo(template.media)">
              <div class="section-item">
                <video width="100%" controls>
                  <source src="{{getVideo(template.media).url}}" type="video/mp4">
                </video>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-12 col-sm-12 col-md-8 offset-md-2">
            <div class="section-item"></div>
            <div class="section-item">
              <div class="section-header">
                <h4 class="h4 pt-2">Review</h4>
              </div>
            </div>
          </div>
        </div> -->

        <div class="row">
          <div class="col-12">
            <div class="slick-wrapper" *ngIf = "getSlideImages(template.media).length > 0" ngImagePixel #bannermageHolder="imagePixel">
              <ngx-slick-carousel
                class="carousel"
                #slickModal="slick-carousel"
                [config]="slideConfig">
                <div ngxSlickItem *ngFor="let slide of getSlideImages(template.media)" class="slide">
                  <img src="{{slide.url}}?{{
                    bannermageHolder.imagePixel
                  }}&&dpr=2&{{ bannermageHolder.aspectRation }}&fit=fill+solid&auto=compress" alt="" width="100%" />
                </div>
              </ngx-slick-carousel>
            </div>
          </div>
        </div>
      </div>

    <!-- Template Courses List -->
      <div class="container" style="padding-top: 10px">
        <div class="col-12 px-0">
          <h1>{{translationScope+'.titles.provider_course' | transloco}}</h1>
        </div>
        <div class="col-12 px-0">
          <p class="p">{{translationScope+'.subtitles.provider_course' | transloco}}</p>
        </div>

        <div class="col-12 px-0 filter-list-container">
          <app-template-filter [templateId]="template.id"></app-template-filter>
          <div class="missing-product">
            <button [routerLink]="['/kursoversikt/request']">
              <span> {{translationScope+'.action_buttons.template_send_request' | transloco}} </span>
            </button>
          </div>
        </div>

        <div class="row global-card mt-5">
          <ng-container *ngIf="(classrooms$ | async).length; else noClassroom">
            <div *ngFor="let classroom of classrooms$ | async" class="col-6 col-sm-6 col-md-6 col-lg-3">
              <app-template-course-card
                [classroom]="classroom"
                [size]="'small'"
                href="/kurs/{{classroom.slug}}">
              </app-template-course-card>
            </div>
          </ng-container>
        </div>
        <div class="missing-product">
          <button [routerLink]="['/kursoversikt/request']">
            <span> {{translationScope+'.action_buttons.template_send_request' | transloco}} </span>
          </button>
        </div>
      </div>
    </section>
  </main>
</div>

<ng-template #noClassroom>
  <div class="no-classroom ">
    <h4>{{translationScope + '.no_course_available' | transloco}}</h4>
  </div>
</ng-template>
